// 该文件专门用于创建整个应用的路由器
import VueRouter from 'vue-router'
// 首页
import Index from '../views/index/Index'
// 通用布局盒子
import CommonLayout from '../layout/CommonLayout'
// 党建
import partyBuild from '../views/partyBuild/Index'
import partyInfo from '../views/partyBuild/info'


// 协会简介
import assocaIntro from '../views/association/Intro'
// 协会章程
import assocaArticle from '../views/association/Article'
//组织架构
import assocaTeam from '../views/association/Team'
//理事会成员
import assocaMember from '../views/association/member'

// 行业自律
import industrySelf from '../views/industrySelf/Index'
import industryInfo from '../views/industrySelf/info'
// 政策法规
import policyRegulate from '../views/policyRegulate/Index'
import policyRegulateInfo from '../views/policyRegulate/info'
// 联系我们
import linkUs from '../views/linkUs/Index'

// 通知公告/协会工作/行业动态
import notice from '../views/notice/Index'
// 对应的详情页
import noticeInfo from '../views/notice/info'

// 会员动态/风采展示
import service from '../views/service/Index'
// 对应详情
import serviceInfo from '../views/service/info'
// 会员风采展示列表
import serviceList from '../views/service/list'

// 查询结果 新闻
import newList from '../views/new/Index'
// 新闻详情
import newInfo from '../views/new/info'

// 继续教育中转页
import turnCenter from '../views/turnCenter/Index'

//创建并暴露一个路由器
export default new VueRouter({
	mode:'hash',
	routes:[
		{
			path: '/',//主要列表
			redirect: '/index',
		},
		{
			path:'/',  //首页
			component:CommonLayout,
			children:[
				{
					path:'index',
					component:Index,
				}
			]
		},
		{
			path:'/partyBuild', //党建
			component:CommonLayout,
			children: [
				{
					path:'/',  //党建
					component:partyBuild,
				},
				{
					path:'info',  //详情
					component:partyInfo,
				},
			]
		},
		{
			path:'/association', //协会简介
			component:CommonLayout,
			children: [
				{
					path:'Intro',  //协会简介
					component:assocaIntro,
				},
				{
					path:'Article',  //协会章程
					component:assocaArticle,
				},
				{
					path:'Team',  //组织架构
					component:assocaTeam,
				},
				{
					path:'Member',  //理事会成员
					component:assocaMember,
				},
			]
		},
		{
			path:'/industrySelf', //行业自律
			component:CommonLayout,
			children: [
				{
					path:'/',  //行业自律
					component:industrySelf,
				},
				{
					path:'info',  //详情
					component:industryInfo,
				},
			]
		},
		{
			path:'/policyRegulate', //政策法规
			component:CommonLayout,
			children: [
				{
					path:'/',  //政策法规
					component:policyRegulate,
				},
				{
					path:'info',  //详情
					component:policyRegulateInfo,
				},
			]
		},
		{
			path:'/', //联系我们
			component:CommonLayout,
			children: [
				{
					path:'linkUs',  //联系我们
					component:linkUs,
				},
			]
		},
		{
			path:'/notice', //通知公告/协会工作/行业动态
			component:CommonLayout,
			children: [
				{
					path:'/',  //通知公告/协会工作/行业动态
					component:notice,
				},
				{
					path:'info',  //详情
					component:noticeInfo,
				},
			]
		},
		// 会员动态/风采展示
		{
			path:'/service', //会员动态/风采展示
			component:CommonLayout,
			children: [
				{
					path:'/',  //会员动态/风采展示
					component:service,
				},
				{
					path:'info',  //详情
					component:serviceInfo,
				},
				{
					path: 'list',
					component: serviceList,
				}
			]
		},
		{
			path:'/new', //新闻
			component:CommonLayout,
			children: [
				{
					path:'/',  //新闻
					component:newList,
				},
				{
					path:'info',  //详情
					component:newInfo,
				},
			]
		},
		{
			path:'/', //继续教育中转页
			component:CommonLayout,
			children: [
				{
					path:'turnCenter',  //继续教育中转页
					component:turnCenter,
				},
			]
		},
		
	],
	scrollBehavior(to, from, savedPosition) {
		// 如果 savedPosition 是一个精确的位置，就移动到该位置
		if (savedPosition) {
		  return savedPosition;
		} else {
		  // 如果没有 savedPosition，就保持在页顶
		  return { x: 0, y: 0 };
		}
	  }
})
